(function() { window.GUID_372fecb3_6931_48de_81be_3ee97d73c2da = { getGuid: function() { return "372fecb3-6931-48de-81be-3ee97d73c2da"; } }; })();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var CS;
(function (CS) {
    var Controls;
    (function (Controls) {
        class CSRChartV2 extends Controls.ControlBase {
            get currentScope() {
                var _a;
                return ((_a = this.scopes.find((scope) => scope.selected == true)) !== null && _a !== void 0 ? _a : this.scopes[0]);
            }
            get chartMarginBottom() {
                return this.fontSizeX * 7;
            }
            get chartMarginLeft() {
                return this.fontSizeY * 3.5;
            }
            get ControlId() {
                return this.controlId;
            }
            get $Control() {
                return $(`#${this.ControlId}`);
            }
            get lang() {
                var _a, _b;
                return (_b = (_a = CS.CommonData === null || CS.CommonData === void 0 ? void 0 : CS.CommonData.Current) === null || _a === void 0 ? void 0 : _a.Language) !== null && _b !== void 0 ? _b : "en";
            }
            constructor(props) {
                var _a, _b, _c, _d, _e, _f;
                super(props.controlId);
                this.state = ChartStateEnum.Unready;
                this.datasets = [];
                this.datapoints = [];
                this.scopeDatapoints = [];
                this.frozenCsrMarkers = [];
                this.mcsrMarkers = [];
                this.series = [];
                this.entityBaseIds = new Set();
                this.statFieldIds = new Set();
                /**
                 * Each key is a string in the format "entityBaseId:statFieldId"
                 */
                this.keys = new Set();
                this.datasetDates = new Set();
                this.scopeDates = [];
                this.currentDate = "";
                this.currentDateByEntityBaseId = new Map();
                this.displayNameByEntityBaseId = new Map();
                this.statFieldNameByStatFieldId = new Map();
                this.currentValueByKey = new Map();
                this.timestampByDate = new Map();
                this.scopes = [
                    {
                        label: CS.Helper.formatString(JSRess.XWeeks, 13),
                        value: 13,
                    },
                    {
                        label: CS.Helper.formatString(JSRess.XWeeks, 24),
                        value: 24,
                    },
                    {
                        label: CS.Helper.formatString(JSRess.XWeeks, 32),
                        value: 32,
                    },
                    {
                        label: CS.Helper.formatString(JSRess.XWeeks, 52),
                        value: 52,
                    },
                ];
                this.datasetThemes = [];
                this.textColorY = "rgba(255,255,255,0.87)";
                this.textColorX = "rgba(255,255,255,0.7)";
                this.chartInnerWidth = 0;
                this.chartInnerHeight = window.innerWidth < 600 ? 350 : 400;
                this.chartMarginRight = 0;
                this.chartMarginTop = 8;
                this.resizeTimeout = null;
                this.controlId = props.controlId;
                this.id = props.id;
                this.statUserGraphs = props.statUserGraphs;
                this.defaultScope = (_a = props.defaultScope) !== null && _a !== void 0 ? _a : "max";
                this.hideEverythingButChart = (_b = props.hideEverythingButChart) !== null && _b !== void 0 ? _b : false;
                this.preventInteraction = (_c = props.preventInteraction) !== null && _c !== void 0 ? _c : false;
                this.isLoggedUser = (_d = props.isLoggedUser) !== null && _d !== void 0 ? _d : false;
                this.tooltipUpdatedOnTheMorningOfText =
                    (_e = props.tooltipUpdatedOnTheMorningOfText) !== null && _e !== void 0 ? _e : "";
                this.explanationUpdatedInTheMorningText =
                    (_f = props.explanationUpdatedInTheMorningText) !== null && _f !== void 0 ? _f : "";
            }
            OnControlInstantiation(params) {
                this.controlId = params[0];
            }
            OnDispose() {
                CS.DOM.$win.off(`resize.${this.ControlId}-${this.id}`);
                this.removeMarkerTooltip();
            }
            OnBindEvents() { }
            initialize() {
                return __awaiter(this, void 0, void 0, function* () {
                    try {
                        if (this.state != ChartStateEnum.Unready)
                            return;
                        this.state = ChartStateEnum.Initializing;
                        this.setFontSizes();
                        this.setEntityBaseIds();
                        this.setDisplayNameByEntityBaseId();
                        this.setStatFieldIds();
                        this.setStatFieldNameByStatFieldId();
                        this.setDatasets();
                        this.setDatapoints();
                        this.setKeys();
                        this.setDatasetThemes();
                        this.setDatasetDates();
                        this.setTimestampByDate();
                        this.setScopes();
                        this.setScopeDates();
                        this.setScopeDatapoints();
                        this.setDefaultCurrentDate();
                        this.setHTML();
                        this.setSeries();
                        this.setScopeUI();
                        this.setLegend();
                        yield this.render();
                        this.bindEvents();
                        this.state = ChartStateEnum.Ready;
                        setTimeout(() => __awaiter(this, void 0, void 0, function* () {
                            yield this.handleResize();
                        }), 100);
                    }
                    catch (error) {
                        console.error("Error while initializing CSRChart", error);
                        this.state = ChartStateEnum.Error;
                    }
                });
            }
            unRender() {
                this.removeAreas();
                this.removeFrozenCsrMarkers();
                this.removeMcsrMarkers();
                this.removeLines();
                this.removePoints();
                this.removeTooltip();
                this.removeMarkerTooltip();
                this.removeSVG();
            }
            reRender(props) {
                return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
                    try {
                        this.rootElement.style.minHeight = `${this.rootElement.clientHeight}px`;
                        this.unRender();
                        this.setSeries();
                        this.render(props)
                            .then(() => {
                            this.rootElement.style.minHeight = "";
                            this.setLegend();
                            return resolve();
                        })
                            .catch((error) => {
                            console.error("Error while re-rendering CSRChart.", error);
                            return reject(error);
                        });
                    }
                    catch (error) {
                        console.error("Error while re-rendering CSRChart.", error);
                        return reject(error);
                    }
                }));
            }
            setFontSizes() {
                this.fontSizeX = 12;
                this.fontSizeY = 14;
            }
            setEntityBaseIds() {
                this.entityBaseIds = new Set(this.statUserGraphs.map((statUserGraph) => statUserGraph.EntityBaseId.toString()));
            }
            setDisplayNameByEntityBaseId() {
                this.displayNameByEntityBaseId = new Map(Array.from(this.entityBaseIds).map((entityBaseId) => {
                    var _a;
                    const statUserGraph = this.statUserGraphs.find((statUserGraph) => statUserGraph.EntityBaseId.toString() == entityBaseId);
                    return [entityBaseId, (_a = statUserGraph === null || statUserGraph === void 0 ? void 0 : statUserGraph.DisplayName) !== null && _a !== void 0 ? _a : ""];
                }));
            }
            setStatFieldNameByStatFieldId() {
                this.statFieldNameByStatFieldId = new Map(Array.from(this.statFieldIds).map((statFieldId) => {
                    var _a;
                    const statUserGraph = this.statUserGraphs.find((statUserGraph) => statUserGraph.StatFieldId == statFieldId);
                    return [statFieldId, (_a = statUserGraph === null || statUserGraph === void 0 ? void 0 : statUserGraph.StatFieldName) !== null && _a !== void 0 ? _a : ""];
                }));
            }
            setStatFieldIds() {
                this.statFieldIds = new Set(this.statUserGraphs.map((statUserGraph) => statUserGraph.StatFieldId));
            }
            setDatasets() {
                this.datasets = Array.from(this.entityBaseIds).map((entityBaseId) => {
                    const datapoints = this.statUserGraphs
                        .filter((statUserGraph) => statUserGraph.EntityBaseId.toString() == entityBaseId)
                        .map((statUserGraph) => {
                        var _a, _b, _c, _d, _e;
                        const frozenCsrEvents = (_b = (_a = statUserGraph.FrozenCsrEvents) === null || _a === void 0 ? void 0 : _a.map((frozenCsrEvent) => ({
                            eventId: frozenCsrEvent.EventId,
                            eventImageUrl: frozenCsrEvent.EventImageUrl,
                            eventName: frozenCsrEvent.EventName,
                            displayCsrDate: frozenCsrEvent.DisplayCsrDate,
                            tooltipLabel: frozenCsrEvent.TooltipLabel,
                            eventUrl: frozenCsrEvent.EventUrl,
                            markerDetailsPopupUrl: frozenCsrEvent.MarkerDetailsPopupUrl,
                        }))) !== null && _b !== void 0 ? _b : [];
                        if (frozenCsrEvents.length === 0 &&
                            statUserGraph.HasFrozenCsr === true) {
                            frozenCsrEvents.push({
                                eventId: (_c = statUserGraph.FrozenCsrEventId) !== null && _c !== void 0 ? _c : null,
                                eventImageUrl: statUserGraph.FrozenCsrEventImageUrl,
                                eventName: statUserGraph.FrozenCsrEventName,
                                displayCsrDate: statUserGraph.StatDateString,
                                tooltipLabel: statUserGraph.FrozenCsrTooltipLabel,
                                markerDetailsPopupUrl: statUserGraph.FrozenCsrMarkerDetailsPopupUrl,
                            });
                        }
                        const mcsrEvents = (_e = (_d = statUserGraph.McsrEvents) === null || _d === void 0 ? void 0 : _d.map((mcsrEvent) => ({
                            eventId: mcsrEvent.EventId,
                            eventImageUrl: mcsrEvent.EventImageUrl,
                            eventName: mcsrEvent.EventName,
                            startDateTime: mcsrEvent.StartDateTime,
                            displayDateTime: mcsrEvent.DisplayDateTime,
                            eventUrl: mcsrEvent.EventUrl,
                            markerDetailsPopupUrl: mcsrEvent.MarkerDetailsPopupUrl,
                            mcsrValue: mcsrEvent.McsrValue,
                        }))) !== null && _e !== void 0 ? _e : [];
                        return {
                            entityBaseId,
                            statFieldId: statUserGraph.StatFieldId,
                            value: statUserGraph.Value,
                            date: new Date(statUserGraph.StatDateString).toISOString(),
                            timestamp: statUserGraph.StatDateTimestamp,
                            isEstimated: statUserGraph.IsTransitionStat,
                            isPremiumLocked: statUserGraph.PremiumLocked &&
                                statUserGraph.StatFieldId === "TCSR",
                            frozenCsrEvents,
                            mcsrEvents,
                        };
                    })
                        .sort((a, b) => {
                        if (a.date < b.date)
                            return -1;
                        if (a.date > b.date)
                            return 1;
                        return 0;
                    });
                    const lastDatapointByStatFieldId = new Map();
                    datapoints.forEach((datapoint) => {
                        lastDatapointByStatFieldId.set(datapoint.statFieldId, datapoint);
                    });
                    const lastDatapointDates = Array.from(lastDatapointByStatFieldId.values()).map((datapoint) => datapoint.date);
                    if (new Set(lastDatapointDates).size === lastDatapointDates.length) {
                        const mostRecentDatapoint = Array.from(lastDatapointByStatFieldId.values()).sort((a, b) => b.date.localeCompare(a.date))[0];
                        if (mostRecentDatapoint.statFieldId === "TCSR") {
                            const tcsrDatapoints = datapoints.filter((datapoint) => datapoint.statFieldId === "TCSR");
                            const mostRecentDatapointIndex = tcsrDatapoints.findIndex((datapoint) => datapoint.date === mostRecentDatapoint.date);
                            const datapointsForAverage = tcsrDatapoints.slice(Math.max(0, mostRecentDatapointIndex - 12 + 1), mostRecentDatapointIndex + 1);
                            const average = Math.round(datapointsForAverage.reduce((acc, datapoint) => acc + datapoint.value, 0) / datapointsForAverage.length) || 0;
                            datapoints.forEach((datapoint) => {
                                if (datapoint.date === mostRecentDatapoint.date &&
                                    datapoint.entityBaseId === mostRecentDatapoint.entityBaseId) {
                                    datapoint.isEstimated = true;
                                }
                            });
                            datapoints.push({
                                entityBaseId,
                                statFieldId: "CompuSportRating",
                                value: average,
                                date: mostRecentDatapoint.date,
                                timestamp: mostRecentDatapoint.timestamp,
                                isEstimated: true,
                                isPremiumLocked: mostRecentDatapoint.isPremiumLocked,
                            });
                        }
                    }
                    return {
                        entityBaseId,
                        datapoints,
                    };
                });
            }
            setKeys() {
                this.keys = new Set(Array.from(new Set(this.datapoints.map((datapoint) => `${datapoint.entityBaseId}:${datapoint.statFieldId}`))).sort((a, b) => {
                    const [, symbolA] = a.split(":");
                    const [, symbolB] = b.split(":");
                    if (symbolA === symbolB)
                        return 0;
                    if (symbolA === "TCSR")
                        return -1;
                    if (symbolB === "TCSR")
                        return 1;
                    return 0;
                }));
            }
            setDatapoints() {
                this.datapoints = this.datasets.reduce((datapoints, dataset) => datapoints.concat(dataset.datapoints), []);
            }
            setSeries() {
                this.series = Array.from(this.keys).map((key) => {
                    const [entityBaseId, symbol] = key.split(":");
                    const datapoints = this.scopeDatapoints.filter((datapoint) => datapoint.entityBaseId == entityBaseId &&
                        datapoint.statFieldId == symbol);
                    return {
                        key,
                        entityBaseId,
                        symbol,
                        datapoints,
                    };
                });
            }
            setDatasetThemes() {
                this.datasetThemes = this.datasets.map((dataset, index) => {
                    const color = new Map();
                    color.set("CompuSportRating", "#979797");
                    color.set("TCSR", "#979797");
                    if (index === 0) {
                        color.set("CompuSportRating", "#FDD835");
                        color.set("TCSR", "#FFF59D");
                    }
                    else if (index === 1) {
                        color.set("CompuSportRating", "#03a9f4");
                        color.set("TCSR", "#B3E5FC");
                    }
                    return {
                        entityBaseId: dataset.entityBaseId,
                        palette: {
                            color,
                            areaColor: color,
                            lineColor: color,
                            pointColor: color,
                        },
                    };
                });
            }
            setDatasetDates() {
                this.datasetDates = new Set(this.datapoints.map((datapoint) => datapoint.date).sort());
            }
            setTimestampByDate() {
                this.timestampByDate = new Map(Array.from(this.datasetDates).map((date) => {
                    const datapoint = this.datapoints.find((d) => d.date === date);
                    if (datapoint) {
                        return [date, datapoint.timestamp];
                    }
                }));
            }
            setScopes() {
                // Filter scopes to only include those less than or equal to the number of dates
                this.scopes = this.scopes.filter((scope) => scope.value <= this.datasetDates.size);
                // Add a scope equal to the number of dates if none exist
                if (!this.scopes.length) {
                    this.scopes.push({
                        label: CS.Helper.formatString(JSRess.XWeeks, this.datasetDates.size),
                        value: this.datasetDates.size,
                    });
                }
                // Add an "All time" scope if dates exceed the maximum scope value
                if (this.datasetDates.size > this.scopes[this.scopes.length - 1].value) {
                    this.scopes.push({
                        label: JSRess.AllTime,
                        value: this.datasetDates.size,
                    });
                }
                // Ensure at least one scope is available
                if (!this.scopes.length)
                    throw new Error("No scopes available");
                // Set the first scope as selected
                this.scopes[0].selected = true;
            }
            setScopeDates(newScopeDates) {
                if (newScopeDates) {
                    this.scopeDates = newScopeDates;
                    return;
                }
                this.scopeDates = Array.from(this.datasetDates).slice(-this.currentScope.value, this.datasetDates.size);
            }
            setScopeDatapoints() {
                this.scopeDatapoints = this.datapoints
                    .filter((datapoint) => this.scopeDates.includes(datapoint.date))
                    .sort((a, b) => {
                    if (a.date < b.date)
                        return -1;
                    if (a.date > b.date)
                        return 1;
                    return 0;
                });
            }
            setFrozenCsrMarkers() {
                const markersByDate = new Map();
                this.scopeDatapoints
                    .filter((datapoint) => datapoint.statFieldId === "CompuSportRating")
                    .forEach((datapoint) => {
                    var _a, _b, _c, _d, _e, _f;
                    const events = (_a = datapoint.frozenCsrEvents) !== null && _a !== void 0 ? _a : [];
                    if (!events.length) {
                        return;
                    }
                    const marker = (_b = markersByDate.get(datapoint.date)) !== null && _b !== void 0 ? _b : {
                        date: datapoint.date,
                        timestamp: datapoint.timestamp,
                        iconUrl: null,
                        detailsPopupUrl: null,
                        csrValue: null,
                        events: [],
                    };
                    marker.events.push(...events);
                    marker.timestamp = datapoint.timestamp;
                    marker.csrValue = datapoint.value;
                    if (!marker.iconUrl) {
                        marker.iconUrl =
                            (_d = (_c = events.find((event) => !!event.eventImageUrl)) === null || _c === void 0 ? void 0 : _c.eventImageUrl) !== null && _d !== void 0 ? _d : null;
                    }
                    if (!marker.detailsPopupUrl) {
                        marker.detailsPopupUrl =
                            (_f = (_e = events.find((event) => !!event.markerDetailsPopupUrl)) === null || _e === void 0 ? void 0 : _e.markerDetailsPopupUrl) !== null && _f !== void 0 ? _f : null;
                    }
                    markersByDate.set(datapoint.date, marker);
                });
                this.frozenCsrMarkers = Array.from(markersByDate.values())
                    .map((marker) => {
                    var _a, _b, _c, _d, _e, _f;
                    const uniqueEventsByKey = new Map();
                    marker.events.forEach((event, index) => {
                        var _a, _b;
                        const key = `${(_a = event.eventId) !== null && _a !== void 0 ? _a : "null"}-${event.displayCsrDate}-${(_b = event.eventName) !== null && _b !== void 0 ? _b : index}`;
                        if (!uniqueEventsByKey.has(key)) {
                            uniqueEventsByKey.set(key, event);
                        }
                    });
                    const uniqueEvents = Array.from(uniqueEventsByKey.values()).sort((a, b) => {
                        var _a, _b, _c, _d;
                        const dateA = (_b = (_a = this.tryParseDate(a.displayCsrDate)) === null || _a === void 0 ? void 0 : _a.getTime()) !== null && _b !== void 0 ? _b : 0;
                        const dateB = (_d = (_c = this.tryParseDate(b.displayCsrDate)) === null || _c === void 0 ? void 0 : _c.getTime()) !== null && _d !== void 0 ? _d : 0;
                        return dateA - dateB;
                    });
                    const iconUrl = (_c = (_a = marker.iconUrl) !== null && _a !== void 0 ? _a : (_b = uniqueEvents.find((event) => !!event.eventImageUrl)) === null || _b === void 0 ? void 0 : _b.eventImageUrl) !== null && _c !== void 0 ? _c : null;
                    const detailsPopupUrl = (_f = (_d = marker.detailsPopupUrl) !== null && _d !== void 0 ? _d : (_e = uniqueEvents.find((event) => !!event.markerDetailsPopupUrl)) === null || _e === void 0 ? void 0 : _e.markerDetailsPopupUrl) !== null && _f !== void 0 ? _f : null;
                    return Object.assign(Object.assign({}, marker), { iconUrl,
                        detailsPopupUrl, events: uniqueEvents });
                })
                    .sort((a, b) => a.timestamp - b.timestamp);
            }
            setMcsrMarkers() {
                const markersByDate = new Map();
                this.scopeDatapoints
                    .filter((datapoint) => datapoint.statFieldId === "CompuSportRating")
                    .forEach((datapoint) => {
                    var _a, _b, _c, _d, _e, _f, _g, _h;
                    const events = (_a = datapoint.mcsrEvents) !== null && _a !== void 0 ? _a : [];
                    if (!events.length) {
                        return;
                    }
                    const marker = (_b = markersByDate.get(datapoint.date)) !== null && _b !== void 0 ? _b : {
                        date: datapoint.date,
                        timestamp: datapoint.timestamp,
                        iconUrl: null,
                        detailsPopupUrl: null,
                        csrValue: null,
                        mcsrValue: null,
                        events: [],
                    };
                    marker.events.push(...events);
                    marker.timestamp = datapoint.timestamp;
                    marker.csrValue = datapoint.value;
                    if (marker.mcsrValue == null) {
                        marker.mcsrValue =
                            (_d = (_c = events.find((event) => event.mcsrValue != null)) === null || _c === void 0 ? void 0 : _c.mcsrValue) !== null && _d !== void 0 ? _d : null;
                    }
                    if (!marker.iconUrl) {
                        marker.iconUrl =
                            (_f = (_e = events.find((event) => !!event.eventImageUrl)) === null || _e === void 0 ? void 0 : _e.eventImageUrl) !== null && _f !== void 0 ? _f : null;
                    }
                    if (!marker.detailsPopupUrl) {
                        marker.detailsPopupUrl =
                            (_h = (_g = events.find((event) => !!event.markerDetailsPopupUrl)) === null || _g === void 0 ? void 0 : _g.markerDetailsPopupUrl) !== null && _h !== void 0 ? _h : null;
                    }
                    markersByDate.set(datapoint.date, marker);
                });
                this.mcsrMarkers = Array.from(markersByDate.values())
                    .map((marker) => {
                    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
                    const uniqueEventsByKey = new Map();
                    marker.events.forEach((event, index) => {
                        var _a, _b;
                        const key = `${(_a = event.eventId) !== null && _a !== void 0 ? _a : "null"}-${event.displayDateTime}-${(_b = event.eventName) !== null && _b !== void 0 ? _b : index}`;
                        if (!uniqueEventsByKey.has(key)) {
                            uniqueEventsByKey.set(key, event);
                        }
                    });
                    const uniqueEvents = Array.from(uniqueEventsByKey.values()).sort((a, b) => {
                        var _a, _b, _c, _d;
                        const dateA = (_b = (_a = this.tryParseDate(a.displayDateTime)) === null || _a === void 0 ? void 0 : _a.getTime()) !== null && _b !== void 0 ? _b : 0;
                        const dateB = (_d = (_c = this.tryParseDate(b.displayDateTime)) === null || _c === void 0 ? void 0 : _c.getTime()) !== null && _d !== void 0 ? _d : 0;
                        return dateA - dateB;
                    });
                    const primaryEventWithImage = uniqueEvents.find((event) => !!event.eventImageUrl && !!event.displayDateTime);
                    const primaryEventWithDate = uniqueEvents.find((event) => !!event.displayDateTime);
                    const primaryEvent = (_a = primaryEventWithImage !== null && primaryEventWithImage !== void 0 ? primaryEventWithImage : primaryEventWithDate) !== null && _a !== void 0 ? _a : uniqueEvents[0];
                    const iconUrl = (_e = (_c = (_b = marker.iconUrl) !== null && _b !== void 0 ? _b : primaryEvent === null || primaryEvent === void 0 ? void 0 : primaryEvent.eventImageUrl) !== null && _c !== void 0 ? _c : (_d = uniqueEvents.find((event) => !!event.eventImageUrl)) === null || _d === void 0 ? void 0 : _d.eventImageUrl) !== null && _e !== void 0 ? _e : null;
                    const detailsPopupUrl = (_j = (_g = (_f = marker.detailsPopupUrl) !== null && _f !== void 0 ? _f : primaryEvent === null || primaryEvent === void 0 ? void 0 : primaryEvent.markerDetailsPopupUrl) !== null && _g !== void 0 ? _g : (_h = uniqueEvents.find((event) => !!event.markerDetailsPopupUrl)) === null || _h === void 0 ? void 0 : _h.markerDetailsPopupUrl) !== null && _j !== void 0 ? _j : null;
                    return Object.assign(Object.assign({}, marker), { iconUrl,
                        detailsPopupUrl, events: uniqueEvents });
                })
                    .sort((a, b) => a.timestamp - b.timestamp);
            }
            setChartMarginTop() {
                this.chartMarginTop = this.frozenCsrMarkers.length > 0 || this.mcsrMarkers.length > 0 ? 52 : 8;
            }
            setDefaultCurrentDate() {
                this.currentDate = this.scopeDates[this.scopeDates.length - 1];
                if (this.rootElement) {
                    const select = this.rootElement.querySelector(".csr-chart__dates-select");
                    if (select) {
                        select.value = this.currentDate;
                    }
                }
                this.setCurrentData();
            }
            setScopeUI() {
                if (!this.scopes.length)
                    throw new Error("No scopes available");
                this.scopes.forEach((scope) => {
                    var _a;
                    const scopeButton = (_a = this.rootElement) === null || _a === void 0 ? void 0 : _a.querySelector(`.csr-chart__scopes-button[data-value="${scope.value}"]`);
                    if (!scopeButton)
                        throw new Error("Scope button not found");
                    scopeButton.classList.toggle("csr-chart__scopes-button--selected", scope.selected == true);
                });
            }
            setLegend() {
                const legendElement = this.rootElement.querySelector(".csr-chart__legend");
                if (!legendElement)
                    throw new Error("Legend element not found");
                legendElement.innerHTML = "";
                if (this.entityBaseIds.size === 1) {
                    this.setLegendItemsForStatFields(legendElement);
                }
                else {
                    this.setLegendItemsForEntities(legendElement);
                }
            }
            setLegendItemsForEntities(legendElement) {
                Array.from(this.statFieldIds).forEach((statFieldId) => {
                    if (statFieldId === "TCSR")
                        return;
                    const legendRow = document.createElement("div");
                    legendRow.classList.add("csr-chart__legend__row");
                    Array.from(this.entityBaseIds).forEach((entityBaseId) => {
                        var _a, _b, _c, _d;
                        const color = (_a = this.datasetThemes
                            .find((theme) => theme.entityBaseId == entityBaseId)) === null || _a === void 0 ? void 0 : _a.palette.color.get(statFieldId);
                        if (!color)
                            return;
                        const value = (_b = this.currentValueByKey.get(`${entityBaseId}:${statFieldId}`)) !== null && _b !== void 0 ? _b : "N/A";
                        const legendItem = document.createElement("div");
                        legendItem.setAttribute("data-entity-base-id", entityBaseId);
                        legendItem.classList.add("csr-chart__legend__item");
                        if (value === "N/A") {
                            legendItem.classList.add("csr-chart__legend__item--not-available");
                        }
                        const label = CS.Helper.formatString(JSRess.Names_StatField, (_c = this.displayNameByEntityBaseId.get(entityBaseId)) !== null && _c !== void 0 ? _c : "", (_d = this.statFieldNameByStatFieldId.get(statFieldId)) !== null && _d !== void 0 ? _d : "");
                        legendItem.innerHTML = `
            <div class="csr-chart__legend__item__color" style="background-color: ${color};"></div>
            <div class="csr-chart__legend__item__label">${label}</div>
            <div class="csr-chart__legend__item__value">
              ${value}
            </div>
          `;
                        legendRow.appendChild(legendItem);
                    });
                    legendElement.appendChild(legendRow);
                });
            }
            setLegendItemsForStatFields(legendElement) {
                Array.from(this.statFieldIds).forEach((statFieldId) => {
                    const color = this.datasetThemes[0].palette.color.get(statFieldId);
                    if (!color)
                        return;
                    const legendItem = document.createElement("div");
                    legendItem.classList.add("csr-chart__legend__item");
                    // legendItem.style.fontSize = "1.15em";
                    legendItem.innerHTML = `
            <div class="csr-chart__legend__item__color" style="background-color: ${color}; font-size: 0.8em;"></div>
            <div class="csr-chart__legend__item__label">${this.statFieldNameByStatFieldId.get(statFieldId)}</div>
            <div class="csr-chart__legend__item__value">
              ${this.currentValueByKey.get(`${Array.from(this.entityBaseIds)[0]}:${statFieldId}`)}
            </div>
          `;
                    legendElement.appendChild(legendItem);
                });
            }
            setChartDimensions() {
                return new Promise((resolve, reject) => {
                    try {
                        // The chart is often rendered within an element that is hidden by default and then animated.
                        // By requesting an animation frame, we ensure that the chart is rendered after the element is visible.
                        requestAnimationFrame(() => {
                            const spacing = this.getXAxisSpacing();
                            this.chartInnerWidth = spacing * this.scopeDates.length;
                            return resolve();
                        });
                    }
                    catch (error) {
                        console.error("Error while setting chart dimensions.", error);
                        return reject(error);
                    }
                });
            }
            getXAxisSpacing() {
                try {
                    let spacing = this.fontSizeX * 2;
                    const containeRect = this.chartContainerElement.getBoundingClientRect();
                    const area = containeRect.width - this.chartMarginLeft - this.chartMarginRight;
                    if (area <= 0) {
                        return spacing;
                    }
                    const range = this.scopeDates.length - 1;
                    spacing = area / range;
                    return spacing;
                }
                catch (error) {
                    console.error("Error while getting spacing for x axis ticks.", error);
                    return this.fontSizeX * 2;
                }
            }
            setHTML() {
                this.rootElement = document.getElementById(this.id);
                if (!this.rootElement)
                    throw new Error("Root element not found");
                const dateOptions = Array.from(this.datasetDates)
                    .reverse()
                    .map((date) => `<option value="${date}">${this.formatLocalizedDisplayDate(date)}</option>`)
                    .join("");
                const scopeButtons = this.scopes
                    .map((scope) => `<div class="csr-chart__scopes-button" data-value="${scope.value}">${scope.label}</div>`)
                    .join("");
                const scopesMarkup = `
      <div class="csr-chart__scopes${this.hideEverythingButChart ? " hiddenforced" : ""}">
        ${scopeButtons}
      </div>`;
                const chartContainerMarkup = `
      <div id="${this.id}-chart-container" class="chart-container">
        <div id="${this.id}-chart" class="chart"></div>
      </div>`;
                const scrollButtonsMarkup = `
      <div class="csr-chart__scroll-buttons${this.hideEverythingButChart ? " hiddenforced" : ""}">
        <button class="csr-chart__scroll-left csr-chart__scroll-button" data-count="-10"><<<</button>
        <button class="csr-chart__scroll-left csr-chart__scroll-button" data-count="-5"><<</button>
        <button class="csr-chart__scroll-left csr-chart__scroll-button" data-count="-1"><</button>
        <button class="csr-chart__scroll-right csr-chart__scroll-button" data-count="1">></button>
        <button class="csr-chart__scroll-right csr-chart__scroll-button" data-count="5">>></button>
        <button class="csr-chart__scroll-right csr-chart__scroll-button" data-count="10">>>></button>
      </div>`;
                const legendMarkup = `
      <div class="csr-chart__legend${this.hideEverythingButChart ? " hiddenforced" : ""}">
      </div>`;
                const dateSelectMarkup = `
      <div class="csr-chart__dates${this.hideEverythingButChart ? " hiddenforced" : ""}">
        <select class="csr-chart__dates-select">${dateOptions}</select>
        </div>`;
                const explanationSectionMarkup = `<div class="csr-chart__explanation-section${this.hideEverythingButChart ? " hiddenforced" : ""}"></div>`;
                this.rootElement.innerHTML = `
      ${dateSelectMarkup}
      ${this.entityBaseIds.size === 1 ? explanationSectionMarkup : ""}
      ${scopesMarkup}
      ${legendMarkup}
      ${chartContainerMarkup}
      ${scrollButtonsMarkup}`;
                this.chartContainerElement = document.getElementById(`${this.id}-chart-container`);
                if (!this.chartContainerElement) {
                    throw new Error("Chart container element not found");
                }
                const select = this.rootElement.querySelector(".csr-chart__dates-select");
                if (!select)
                    throw new Error("Select element not found");
                if (this.preventInteraction) {
                    select.disabled = true;
                }
            }
            render(props) {
                return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
                    try {
                        yield this.setChartDimensions();
                        this.setFrozenCsrMarkers();
                        this.setMcsrMarkers();
                        this.setChartMarginTop();
                        this.setScales();
                        this.setSVG();
                        this.drawAxes();
                        this.drawAreas();
                        this.drawLines();
                        this.drawFrozenCsrMarkers();
                        this.drawMcsrMarkers();
                        this.drawPoints();
                        this.setBisector();
                        this.setTooltip();
                        this.setMarkerTooltip();
                        this.appendSVGNode();
                        if ((props === null || props === void 0 ? void 0 : props.isResizing) != true) {
                            if (this.entityBaseIds.size === 1) {
                                this.setExplanationForSelectedDatapoints();
                            }
                            const timestamp = this.timestampByDate.get(this.currentDate);
                            if (timestamp) {
                                this.Trigger(Controls.CSRChart.EventNames.WeekSelected, {
                                    jqueryEventObject: null,
                                    data: timestamp,
                                });
                            }
                        }
                        return resolve();
                    }
                    catch (error) {
                        console.error("Error while rendering CSRChart.", error);
                        return reject(error);
                    }
                }));
            }
            setScales() {
                this.xScale = d3
                    .scalePoint(this.scopeDates.map((d) => d), [this.chartMarginLeft, this.chartInnerWidth - this.chartMarginRight])
                    .range([
                    this.chartMarginLeft,
                    this.chartInnerWidth - this.chartMarginRight,
                ]);
                const min = d3.min(this.scopeDatapoints, (d) => d.value);
                const max = d3.max(this.scopeDatapoints, (d) => d.value);
                if (min === undefined || max === undefined) {
                    throw new Error("Min or max value is undefined");
                }
                // const grace = 0.01;
                this.yScale = d3
                    .scaleLinear(
                // [min - (max - min) * grace, max + (max - min) * grace],
                [min, max], [this.chartInnerHeight - this.chartMarginBottom, this.chartMarginTop])
                    .nice();
            }
            setSVG() {
                this.svg = d3
                    .create("svg")
                    .attr("viewBox", [0, 0, this.chartInnerWidth, this.chartInnerHeight])
                    .attr("width", this.chartInnerWidth)
                    .attr("height", this.chartInnerHeight)
                    .attr("class", "csr-chart__svg")
                    .attr("style", "max-width: 100%; height: auto; height: intrinsic; cursor: pointer")
                    .style("-webkit-tap-highlight-color", "transparent")
                    .style("overflow", "visible")
                    .on("pointerenter pointermove", this.handlePointerMove.bind(this))
                    .on("pointerleave", this.handlePointerLeave.bind(this))
                    .on("click", this.handleClick.bind(this));
            }
            hideTooltip() {
                this.tooltip.style("opacity", "0");
            }
            hideFrozenCsrMarkerTooltip() {
                if (this.markerTooltip) {
                    this.markerTooltip.style("opacity", "0");
                }
            }
            drawFrozenCsrMarkerTooltip(marker, event) {
                var _a, _b, _c, _d;
                if (!this.markerTooltip) {
                    return;
                }
                const markerDisplayDate = this.getFrozenCsrMarkerDisplayDate(marker);
                this.markerTooltip.style("opacity", "1").html(`
          <div class="csr-chart__marker-tooltip__title">
            ${this.formatFrozenCsrEventDate(markerDisplayDate)}
          </div>
          <div class="csr-chart__marker-tooltip__csr">
            CSR: ${this.formatCsrValue(marker.csrValue)}
          </div>
          <div class="csr-chart__marker-tooltip__content">
            ${marker.events
                    .map((frozenCsrEvent) => {
                    var _a, _b;
                    const tooltipLabel = (_b = (_a = frozenCsrEvent.tooltipLabel) !== null && _a !== void 0 ? _a : frozenCsrEvent.eventName) !== null && _b !== void 0 ? _b : "";
                    return `
                  <div class="csr-chart__marker-tooltip__content-item">
                    <div class="csr-chart__marker-tooltip__content-item-label">${tooltipLabel}</div>
                  </div>
                `;
                })
                    .join("")}
          </div>
      `);
                const tooltipOuterWidth = (_b = (_a = this.markerTooltip.node()) === null || _a === void 0 ? void 0 : _a.clientWidth) !== null && _b !== void 0 ? _b : 0;
                const pointerXPos = d3.pointer(event, this.chartContainerElement)[0];
                const chartClientWidth = (_d = (_c = this.chartContainerElement) === null || _c === void 0 ? void 0 : _c.clientWidth) !== null && _d !== void 0 ? _d : 1;
                const isOnLeftSide = pointerXPos < chartClientWidth / 2;
                const tooltipXPos = isOnLeftSide
                    ? pointerXPos + 20
                    : pointerXPos - tooltipOuterWidth - 20;
                this.markerTooltip.style("left", `${tooltipXPos}px`);
            }
            shouldOpenFrozenCsrMarkerDetailsPopup(target) {
                if (!(target instanceof Element)) {
                    return false;
                }
                return (target.classList.contains("frozen-csr-marker-icon-bg") ||
                    target.classList.contains("frozen-csr-marker-icon") ||
                    target.classList.contains("frozen-csr-marker-date"));
            }
            tryParseDate(value) {
                if (!value) {
                    return null;
                }
                const date = new Date(value);
                if (!isNaN(date.getTime())) {
                    return date;
                }
                const match = /\/Date\((\d+)(?:[+-]\d+)?\)\//.exec(value);
                if (match === null || match === void 0 ? void 0 : match[1]) {
                    const timestamp = Number(match[1]);
                    if (!isNaN(timestamp)) {
                        return new Date(timestamp);
                    }
                }
                return null;
            }
            formatDisplayDate(value, pattern) {
                const parsedDate = this.tryParseDate(value);
                if (!parsedDate) {
                    return value !== null && value !== void 0 ? value : "";
                }
                return d3.utcFormat(pattern)(parsedDate);
            }
            formatLocalizedDisplayDateShort(value) {
                const parsedDate = this.tryParseDate(value);
                if (!parsedDate) {
                    return value !== null && value !== void 0 ? value : "";
                }
                const localizedDate = new Date(parsedDate.getUTCFullYear(), parsedDate.getUTCMonth(), parsedDate.getUTCDate());
                return CS.Helper.AddSuffixToDay(localizedDate, localizedDate.toLocaleDateString(this.lang, {
                    month: "short",
                    day: "numeric",
                }));
            }
            formatISODate(value) {
                const parsedDate = this.tryParseDate(value);
                if (!parsedDate) {
                    return value !== null && value !== void 0 ? value : "";
                }
                return parsedDate.toISOString().slice(0, 10);
            }
            formatLocalizedDisplayDate(value) {
                const parsedDate = this.tryParseDate(value);
                if (!parsedDate) {
                    return value !== null && value !== void 0 ? value : "";
                }
                const localizedDate = new Date(parsedDate.getUTCFullYear(), parsedDate.getUTCMonth(), parsedDate.getUTCDate());
                return CS.Helper.AddSuffixToDay(localizedDate, localizedDate.toLocaleDateString(this.lang, {
                    month: "short",
                    day: "numeric",
                    year: "numeric",
                }));
            }
            getFrozenCsrMarkerDisplayDate(marker) {
                var _a, _b, _c;
                if (!((_a = marker.events) === null || _a === void 0 ? void 0 : _a.length)) {
                    return marker.date;
                }
                const primaryEventWithImage = marker.events.find((frozenCsrEvent) => !!frozenCsrEvent.eventImageUrl && !!frozenCsrEvent.displayCsrDate);
                const firstEventWithDate = marker.events.find((frozenCsrEvent) => !!frozenCsrEvent.displayCsrDate);
                return ((_c = (_b = primaryEventWithImage === null || primaryEventWithImage === void 0 ? void 0 : primaryEventWithImage.displayCsrDate) !== null && _b !== void 0 ? _b : firstEventWithDate === null || firstEventWithDate === void 0 ? void 0 : firstEventWithDate.displayCsrDate) !== null && _c !== void 0 ? _c : marker.date);
            }
            getMcsrMarkerDisplayDate(marker) {
                var _a, _b, _c;
                if (!((_a = marker.events) === null || _a === void 0 ? void 0 : _a.length)) {
                    return marker.date;
                }
                const primaryEventWithImage = marker.events.find((mcsrEvent) => !!mcsrEvent.eventImageUrl && !!mcsrEvent.displayDateTime);
                const firstEventWithDate = marker.events.find((mcsrEvent) => !!mcsrEvent.displayDateTime);
                return ((_c = (_b = primaryEventWithImage === null || primaryEventWithImage === void 0 ? void 0 : primaryEventWithImage.displayDateTime) !== null && _b !== void 0 ? _b : firstEventWithDate === null || firstEventWithDate === void 0 ? void 0 : firstEventWithDate.displayDateTime) !== null && _c !== void 0 ? _c : marker.date);
            }
            formatFrozenCsrMarkerDate(value) {
                return this.formatLocalizedDisplayDateShort(value);
            }
            formatFrozenCsrEventDate(value) {
                return this.formatLocalizedDisplayDate(value);
            }
            formatCsrValue(value) {
                if (value == null || isNaN(value)) {
                    return "N/A";
                }
                return `${Math.round(value)}`;
            }
            drawTooltip(datapoint) {
                var _a, _b, _c, _d;
                const datapoints = this.scopeDatapoints
                    .filter((d) => d.date == datapoint.date)
                    .sort((a, b) => {
                    if (a.value < b.value)
                        return 1;
                    if (a.value > b.value)
                        return -1;
                    return 0;
                });
                const morningUpdateCopy = !datapoint.isEstimated && this.tooltipUpdatedOnTheMorningOfText
                    ? `<div class="csr-chart__tooltip__pretitle">${this.tooltipUpdatedOnTheMorningOfText}</div>`
                    : "";
                this.tooltip.style("opacity", "1").attr("class", "csr-chart__tooltip")
                    .html(`
         ${morningUpdateCopy}
         <div class="csr-chart__tooltip__title">${this.formatLocalizedDisplayDate(datapoint.date)}</div>
          <div class="csr-chart__tooltip__content">
          ${datapoints
                    .filter((d) => d.isPremiumLocked != true || d.statFieldId == "CompuSportRating")
                    .map((d) => {
                    var _a, _b;
                    const symbol = d.statFieldId;
                    // const isTCSRPremiumLocked =
                    //   (symbol?.premiumLocked ?? false) && d.symbol.includes("TCSR");
                    if (!symbol /*|| isTCSRPremiumLocked*/) {
                        return "";
                    }
                    const color = this.getAreaFillColor(d.entityBaseId, symbol);
                    const label = CS.Helper.formatString(JSRess.Names_StatField, (_a = this.displayNameByEntityBaseId.get(d.entityBaseId)) !== null && _a !== void 0 ? _a : "", (_b = this.statFieldNameByStatFieldId.get(d.statFieldId)) !== null && _b !== void 0 ? _b : "");
                    return `<div class="csr-chart__tooltip__content__item">
              <div class="csr-chart__tooltip__content__item__color" style="background-color: ${color};"></div>
              <div class="csr-chart__tooltip__content__item__label">${label}</div>
              <div class="csr-chart__tooltip__content__item__value">${d.value}</div>
              </div>`;
                })
                    .join("")}
            </div>
        `);
                const tooltipOuterWidth = (_b = (_a = this.tooltip.node()) === null || _a === void 0 ? void 0 : _a.clientWidth) !== null && _b !== void 0 ? _b : 0;
                const pointerXPos = d3.pointer(event, this.chartContainerElement)[0];
                const chartClientWidth = (_d = (_c = this.chartContainerElement) === null || _c === void 0 ? void 0 : _c.clientWidth) !== null && _d !== void 0 ? _d : 1;
                const isOnLeftSide = pointerXPos < chartClientWidth / 2;
                const tooltipXPos = isOnLeftSide
                    ? pointerXPos + 20
                    : pointerXPos - tooltipOuterWidth - 20;
                this.tooltip.style("left", `${tooltipXPos}px`);
            }
            handlePointerMove(event) {
                this.hideFrozenCsrMarkerTooltip();
                let xPos = d3.pointer(event)[0];
                const domain = this.xScale.domain();
                const range = this.xScale.range();
                const rangePoints = d3.range(range[0], range[1], this.xScale.step());
                const date = domain[this.bisect(rangePoints, xPos - this.xScale.step()) +
                    (xPos < this.xScale.step() * 2 ? 0 : 1)];
                const datapoint = this.scopeDatapoints.find((d) => d.date === date);
                if (!datapoint) {
                    this.hideTooltip();
                    return;
                }
                this.drawTooltip(datapoint);
            }
            handlePointerLeave() {
                this.hideTooltip();
                this.hideFrozenCsrMarkerTooltip();
            }
            handleClick(event) {
                return __awaiter(this, void 0, void 0, function* () {
                    this.hideFrozenCsrMarkerTooltip();
                    const pointer = d3.pointer(event);
                    const xPos = pointer[0];
                    const domain = this.xScale.domain();
                    const range = this.xScale.range();
                    const rangePoints = d3.range(range[0], range[1], this.xScale.step());
                    const date = domain[this.bisect(rangePoints, xPos - this.xScale.step()) +
                        (xPos < this.xScale.step() * 2 ? 0 : 1)];
                    this.setCurrentDate(date);
                });
            }
            drawAxes() {
                this.svg
                    .append("g")
                    .attr("class", "csr-chart__x-axis")
                    .attr("transform", `translate(0, ${this.chartInnerHeight - this.chartMarginBottom})`)
                    .call(d3
                    .axisBottom(this.xScale)
                    .ticks(this.chartInnerHeight / 80)
                    .tickSizeOuter(0)
                    .tickFormat(this.formatDateLabel.bind(this)))
                    .call((g) => g
                    .selectAll(".tick line")
                    .clone()
                    .attr("y2", -this.chartInnerHeight +
                    this.chartMarginBottom +
                    this.chartMarginTop)
                    .attr("stroke-opacity", 0.01))
                    .selectAll("text")
                    .attr("transform", "translate(-13,5)rotate(-60)")
                    .attr("font-size", this.fontSizeX)
                    .attr("fill", this.textColorX)
                    .style("font-family", "Open Sans")
                    .style("text-anchor", "end");
                this.svg
                    .append("g")
                    .attr("class", "csr-chart__y-axis")
                    .attr("transform", `translate(${this.chartMarginLeft}, 0)`)
                    .call(d3
                    .axisLeft(this.yScale)
                    .ticks(this.chartInnerWidth / 80)
                    .tickSizeOuter(0))
                    .call((g) => g
                    .selectAll(".tick line")
                    .clone()
                    .attr("x2", this.chartInnerWidth -
                    this.chartMarginLeft -
                    this.chartMarginRight)
                    .attr("stroke-opacity", 0.05))
                    .selectAll("text")
                    .attr("font-size", this.fontSizeY)
                    .style("font-family", "Open Sans")
                    .attr("fill", this.textColorY);
            }
            formatDateLabel(date, index) {
                if (!date)
                    return "";
                if (this.scopeDates.length > 96 && index % 8 !== 0)
                    return "";
                if (this.scopeDates.length > 32 && index % 3 !== 0)
                    return "";
                if (this.scopeDates.length > 13 && index % 2 !== 0)
                    return "";
                return this.formatISODate(date);
            }
            removeAreas() {
                if (this.svg) {
                    this.svg.selectAll(".area").remove();
                }
            }
            drawAreas() {
                this.removeAreas();
                const area = d3
                    .area()
                    .defined((d) => {
                    var _a;
                    return !isNaN((_a = d.value) !== null && _a !== void 0 ? _a : NaN) &&
                        (d.isPremiumLocked != true || d.statFieldId == "CompuSportRating");
                })
                    .x((d) => { var _a; return (_a = this.xScale(d.date)) !== null && _a !== void 0 ? _a : -1; })
                    .y0(this.chartInnerHeight - this.chartMarginBottom)
                    .y1((d) => this.yScale(d.value));
                Array.from(this.keys).map((key) => {
                    const [entityBaseId, symbol] = key.split(":");
                    let datapoints = this.scopeDatapoints.filter((datapoint) => (datapoint.isPremiumLocked != true ||
                        datapoint.statFieldId == "CompuSportRating") &&
                        datapoint.entityBaseId == entityBaseId &&
                        datapoint.statFieldId == symbol);
                    if (symbol === "TCSR") {
                        const index = datapoints.findIndex((d) => d.date === this.currentDateByEntityBaseId.get(entityBaseId));
                        if (index === -1) {
                            datapoints = [];
                        }
                        else {
                            datapoints = datapoints.slice(Math.max(0, index - 12 + 1), Math.min(index + 1, datapoints.length));
                        }
                    }
                    const gradientId = `${this.id}-gradient-${key}`;
                    const gradient = this.svg
                        .append("defs")
                        .append("linearGradient")
                        .attr("id", gradientId)
                        .attr("x1", "0%")
                        .attr("y1", "0%")
                        .attr("x2", "0%")
                        .attr("y2", "100%");
                    gradient
                        .append("stop")
                        .attr("offset", "0%")
                        .attr("style", `stop-color: ${this.getAreaFillColor(entityBaseId, symbol)}; stop-opacity: ${symbol == "CompuSportRating" ? 0.2 : 0.1}`);
                    gradient
                        .append("stop")
                        .attr("offset", "100%")
                        .attr("style", `stop-color: ${this.getAreaFillColor(entityBaseId, symbol)}; stop-opacity: ${symbol == "CompuSportRating" ? 0.06 : 0.06}`);
                    this.svg
                        .append("path")
                        .attr("class", "area")
                        .datum(datapoints.filter(area.defined()))
                        .attr("d", area)
                        .attr("fill", `url(#${gradientId})`);
                });
            }
            getAreaFillColor(entityBaseId, symbol) {
                var _a;
                const theme = this.datasetThemes.find((theme) => theme.entityBaseId == entityBaseId);
                if (!theme)
                    throw new Error("Theme not found");
                return (_a = theme.palette.color.get(symbol)) !== null && _a !== void 0 ? _a : "";
            }
            removeLines() {
                if (this.serie) {
                    this.serie.remove();
                }
            }
            drawLines() {
                this.removeLines();
                this.serie = this.svg
                    .append("g")
                    .selectAll("g")
                    .data(this.series)
                    .join("g");
                const line = d3
                    .line()
                    .defined((d) => { var _a; return !isNaN((_a = d.value) !== null && _a !== void 0 ? _a : NaN); })
                    .x((d) => { var _a; return (_a = this.xScale(d.date)) !== null && _a !== void 0 ? _a : -1; })
                    .y((d) => this.yScale(d.value));
                this.svg
                    .append("defs")
                    .append("clipPath")
                    .attr("id", "clip")
                    .append("rect")
                    .attr("x", this.chartMarginLeft)
                    .attr("y", this.chartMarginTop)
                    .attr("width", this.chartInnerWidth - this.chartMarginLeft - this.chartMarginRight)
                    .attr("height", this.chartInnerHeight - this.chartMarginTop - this.chartMarginBottom);
                this.serie
                    .append("path")
                    .attr("class", "line line--main")
                    .attr("fill", "none")
                    .attr("stroke-linejoin", "round")
                    .attr("stroke-linecap", "round")
                    .attr("stroke-width", (s) => this.getStrokeWidth(s, "main"))
                    .attr("stroke", this.getStrokeColor.bind(this))
                    .attr("d", (s) => {
                    var _a;
                    return (_a = line(s.datapoints.filter((datapoint, index, datapoints) => {
                        var _a;
                        return (datapoint.isPremiumLocked != true &&
                            this.isWithinDistanceBeforeCurrentDate(datapoint, index, datapoints, 11) &&
                            !isNaN((_a = datapoint.value) !== null && _a !== void 0 ? _a : NaN) &&
                            datapoint.isEstimated != true &&
                            line.defined()(datapoint, index, datapoints));
                    }))) !== null && _a !== void 0 ? _a : "";
                });
                this.serie
                    .append("path")
                    .attr("class", "line--secondary")
                    .attr("fill", "none")
                    .attr("stroke-linejoin", "round")
                    .attr("stroke-linecap", "round")
                    .attr("stroke-width", (s) => this.getStrokeWidth(s, "secondary"))
                    .attr("stroke", this.getStrokeColor.bind(this))
                    .attr("d", (s) => {
                    var _a;
                    return (_a = line(s.datapoints.filter((datapoint, index, datapoints) => {
                        var _a;
                        return (datapoint.isPremiumLocked != true &&
                            !isNaN((_a = datapoint.value) !== null && _a !== void 0 ? _a : NaN) &&
                            datapoint.isEstimated != true &&
                            line.defined()(datapoint, index, datapoints));
                    }))) !== null && _a !== void 0 ? _a : "";
                });
                this.serie
                    .append("path")
                    .attr("class", "line line--dashed")
                    .attr("fill", "none")
                    .attr("stroke-linejoin", "round")
                    .attr("stroke-linecap", "round")
                    .attr("stroke-dasharray", "5 10")
                    .attr("stroke-width", 1)
                    .attr("stroke", this.getStrokeColor.bind(this))
                    .attr("d", (s) => {
                    var _a;
                    return ((_a = line(s.datapoints.filter((datapoint, index, datapoints) => {
                        const isLastOrSecondToLastInScope = index >= datapoints.length - 2;
                        const lastDatapointIsEstimated = datapoints[datapoints.length - 1].isEstimated == true;
                        let isLastOrSecondToLastInDataset = false;
                        if (isLastOrSecondToLastInScope) {
                            const serieDates = Array.from(s.datapoints.map((d) => d.date));
                            const lastDate = Array.from(serieDates).pop();
                            const secondToLastDate = Array.from(serieDates)[serieDates.length - 2];
                            isLastOrSecondToLastInDataset =
                                datapoint.date === lastDate ||
                                    datapoint.date === secondToLastDate;
                        }
                        return ((datapoint.isPremiumLocked != true ||
                            datapoint.statFieldId == "CompuSportRating") &&
                            isLastOrSecondToLastInDataset &&
                            lastDatapointIsEstimated &&
                            line.defined()(datapoint, index, datapoints));
                    }))) !== null && _a !== void 0 ? _a : "");
                });
            }
            removeFrozenCsrMarkers() {
                if (this.svg) {
                    this.svg.selectAll(".frozen-csr-marker-layer").remove();
                }
            }
            drawFrozenCsrMarkers() {
                this.removeFrozenCsrMarkers();
                if (!this.frozenCsrMarkers.length) {
                    return;
                }
                const markersLayer = this.svg
                    .append("g")
                    .attr("class", "frozen-csr-marker-layer");
                const iconSize = 24;
                const iconY = 6;
                const dateY = iconY + iconSize + 16;
                const lineYStart = dateY + 6;
                const lineYEnd = this.chartInnerHeight - this.chartMarginBottom;
                const markerGroups = markersLayer
                    .selectAll("g")
                    .data(this.frozenCsrMarkers)
                    .join("g")
                    .attr("class", "frozen-csr-marker")
                    .attr("transform", (marker) => {
                    var _a;
                    const xPos = (_a = this.xScale(marker.date)) !== null && _a !== void 0 ? _a : -9999;
                    return `translate(${xPos}, 0)`;
                });
                markerGroups
                    .append("line")
                    .attr("class", "frozen-csr-marker-line")
                    .attr("x1", 0)
                    .attr("x2", 0)
                    .attr("y1", lineYStart)
                    .attr("y2", lineYEnd);
                markerGroups
                    .append("text")
                    .attr("class", "frozen-csr-marker-date")
                    .attr("x", 0)
                    .attr("y", dateY)
                    .attr("text-anchor", "middle")
                    .text((marker) => this.formatFrozenCsrMarkerDate(this.getFrozenCsrMarkerDisplayDate(marker)));
                markerGroups.each((marker, index, nodes) => {
                    const markerGroup = d3.select(nodes[index]);
                    const hasIcon = !!marker.iconUrl;
                    const iconContainerSize = iconSize + 4;
                    const iconCornerRadius = 6;
                    const iconClipRadius = 5;
                    markerGroup
                        .append("rect")
                        .attr("class", "frozen-csr-marker-icon-bg")
                        .attr("x", -iconContainerSize / 2)
                        .attr("y", iconY - 2)
                        .attr("width", iconContainerSize)
                        .attr("height", iconContainerSize)
                        .attr("rx", iconCornerRadius)
                        .attr("ry", iconCornerRadius);
                    if (hasIcon) {
                        markerGroup
                            .append("image")
                            .attr("class", "frozen-csr-marker-icon")
                            .attr("x", -iconSize / 2)
                            .attr("y", iconY)
                            .attr("width", iconSize)
                            .attr("height", iconSize)
                            .attr("xlink:href", marker.iconUrl)
                            .attr("preserveAspectRatio", "xMidYMid slice")
                            .attr("clip-path", `inset(0 round ${iconClipRadius}px)`);
                    }
                    else {
                        markerGroup
                            .append("rect")
                            .attr("class", "frozen-csr-marker-icon-fallback")
                            .attr("x", -iconSize / 2)
                            .attr("y", iconY)
                            .attr("width", iconSize)
                            .attr("height", iconSize)
                            .attr("rx", iconClipRadius)
                            .attr("ry", iconClipRadius);
                    }
                    if (marker.events.length > 1) {
                        markerGroup
                            .append("circle")
                            .attr("class", "frozen-csr-marker-count-badge")
                            .attr("cx", iconSize / 2 + 2)
                            .attr("cy", iconY - 3)
                            .attr("r", 8);
                        markerGroup
                            .append("text")
                            .attr("class", "frozen-csr-marker-count-label")
                            .attr("x", iconSize / 2 + 2)
                            .attr("y", iconY)
                            .attr("text-anchor", "middle")
                            .text(`+${marker.events.length - 1}`);
                    }
                });
                markerGroups
                    .on("pointerenter pointermove", (event, marker) => {
                    event.stopPropagation();
                    this.hideTooltip();
                    this.drawFrozenCsrMarkerTooltip(marker, event);
                })
                    .on("pointerleave", (event) => {
                    event.stopPropagation();
                    this.hideFrozenCsrMarkerTooltip();
                })
                    .on("click", (event, marker) => {
                    event.stopPropagation();
                    event.preventDefault();
                    this.hideFrozenCsrMarkerTooltip();
                    if (this.shouldOpenFrozenCsrMarkerDetailsPopup(event.target) &&
                        marker.detailsPopupUrl) {
                        Controls.Popup.ShowAjaxModal(marker.detailsPopupUrl, {}, () => { }, () => { }, true, true);
                        return;
                    }
                    this.setCurrentDate(marker.date);
                });
            }
            removeMcsrMarkers() {
                if (this.svg) {
                    this.svg.selectAll(".mcsr-marker-layer").remove();
                }
            }
            drawMcsrMarkers() {
                this.removeMcsrMarkers();
                if (!this.mcsrMarkers.length) {
                    return;
                }
                const markersLayer = this.svg
                    .append("g")
                    .attr("class", "mcsr-marker-layer");
                const iconSize = 24;
                const iconY = 6;
                const dateY = iconY + iconSize + 16;
                const lineYStart = dateY + 6;
                const lineYEnd = this.chartInnerHeight - this.chartMarginBottom;
                const markerGroups = markersLayer
                    .selectAll("g")
                    .data(this.mcsrMarkers)
                    .join("g")
                    .attr("class", "mcsr-marker")
                    .attr("transform", (marker) => {
                    var _a;
                    const xPos = (_a = this.xScale(marker.date)) !== null && _a !== void 0 ? _a : -9999;
                    return `translate(${xPos}, 0)`;
                });
                markerGroups
                    .append("line")
                    .attr("class", "mcsr-marker-line")
                    .attr("x1", 0)
                    .attr("x2", 0)
                    .attr("y1", lineYStart)
                    .attr("y2", lineYEnd);
                markerGroups
                    .append("text")
                    .attr("class", "mcsr-marker-date")
                    .attr("x", 0)
                    .attr("y", dateY)
                    .attr("text-anchor", "middle")
                    .text((marker) => this.formatFrozenCsrMarkerDate(this.getMcsrMarkerDisplayDate(marker)));
                markerGroups.each((marker, index, nodes) => {
                    const markerGroup = d3.select(nodes[index]);
                    const hasIcon = !!marker.iconUrl;
                    const iconContainerSize = iconSize + 4;
                    const iconCornerRadius = 6;
                    const iconClipRadius = 5;
                    markerGroup
                        .append("rect")
                        .attr("class", "mcsr-marker-icon-bg")
                        .attr("x", -iconContainerSize / 2)
                        .attr("y", iconY - 2)
                        .attr("width", iconContainerSize)
                        .attr("height", iconContainerSize)
                        .attr("rx", iconCornerRadius)
                        .attr("ry", iconCornerRadius);
                    if (hasIcon) {
                        markerGroup
                            .append("image")
                            .attr("class", "mcsr-marker-icon")
                            .attr("x", -iconSize / 2)
                            .attr("y", iconY)
                            .attr("width", iconSize)
                            .attr("height", iconSize)
                            .attr("xlink:href", marker.iconUrl)
                            .attr("preserveAspectRatio", "xMidYMid slice")
                            .attr("clip-path", `inset(0 round ${iconClipRadius}px)`);
                    }
                    else {
                        markerGroup
                            .append("rect")
                            .attr("class", "mcsr-marker-icon-fallback")
                            .attr("x", -iconSize / 2)
                            .attr("y", iconY)
                            .attr("width", iconSize)
                            .attr("height", iconSize)
                            .attr("rx", iconClipRadius)
                            .attr("ry", iconClipRadius);
                    }
                    if (marker.events.length > 1) {
                        markerGroup
                            .append("circle")
                            .attr("class", "mcsr-marker-count-badge")
                            .attr("cx", iconSize / 2 + 2)
                            .attr("cy", iconY - 3)
                            .attr("r", 8);
                        markerGroup
                            .append("text")
                            .attr("class", "mcsr-marker-count-label")
                            .attr("x", iconSize / 2 + 2)
                            .attr("y", iconY)
                            .attr("text-anchor", "middle")
                            .text(`+${marker.events.length - 1}`);
                    }
                });
                markerGroups
                    .on("pointerenter pointermove", (event, marker) => {
                    event.stopPropagation();
                    this.hideTooltip();
                    this.drawMcsrMarkerTooltip(marker, event);
                })
                    .on("pointerleave", (event) => {
                    event.stopPropagation();
                    this.hideMcsrMarkerTooltip();
                })
                    .on("click", (event, marker) => {
                    event.stopPropagation();
                    event.preventDefault();
                    this.hideMcsrMarkerTooltip();
                    if (this.shouldOpenMcsrMarkerDetailsPopup(event.target) &&
                        marker.detailsPopupUrl) {
                        Controls.Popup.ShowAjaxModal(marker.detailsPopupUrl, {}, () => { }, () => { }, true, true);
                        return;
                    }
                    this.setCurrentDate(marker.date);
                });
            }
            shouldOpenMcsrMarkerDetailsPopup(target) {
                if (!(target instanceof Element)) {
                    return false;
                }
                return (target.classList.contains("mcsr-marker-icon-bg") ||
                    target.classList.contains("mcsr-marker-icon") ||
                    target.classList.contains("mcsr-marker-icon-fallback") ||
                    target.classList.contains("mcsr-marker-date"));
            }
            hideMcsrMarkerTooltip() {
                if (this.markerTooltip) {
                    this.markerTooltip.style("opacity", "0");
                }
            }
            drawMcsrMarkerTooltip(marker, event) {
                var _a, _b, _c, _d, _e;
                if (!this.markerTooltip) {
                    return;
                }
                this.markerTooltip.style("opacity", "1").html(`
          <div class="csr-chart__marker-tooltip__title">
            ${this.formatFrozenCsrEventDate(this.getMcsrMarkerDisplayDate(marker))}
          </div>
          <div class="csr-chart__marker-tooltip__csr">
            M-CSR: ${this.formatCsrValue((_a = marker.mcsrValue) !== null && _a !== void 0 ? _a : marker.csrValue)}
          </div>
          <div class="csr-chart__marker-tooltip__content">
            ${marker.events
                    .map((mcsrEvent) => {
                    var _a;
                    const eventName = (_a = mcsrEvent.eventName) !== null && _a !== void 0 ? _a : "";
                    return `
                  <div class="csr-chart__marker-tooltip__content-item">
                    <div class="csr-chart__marker-tooltip__content-item-label">${eventName}</div>
                  </div>
                `;
                })
                    .join("")}
          </div>
      `);
                const tooltipOuterWidth = (_c = (_b = this.markerTooltip.node()) === null || _b === void 0 ? void 0 : _b.clientWidth) !== null && _c !== void 0 ? _c : 0;
                const pointerXPos = d3.pointer(event, this.chartContainerElement)[0];
                const chartClientWidth = (_e = (_d = this.chartContainerElement) === null || _d === void 0 ? void 0 : _d.clientWidth) !== null && _e !== void 0 ? _e : 1;
                const isOnLeftSide = pointerXPos < chartClientWidth / 2;
                const tooltipXPos = isOnLeftSide
                    ? pointerXPos + 20
                    : pointerXPos - tooltipOuterWidth - 20;
                this.markerTooltip.style("left", `${tooltipXPos}px`);
            }
            isWithinDistanceBeforeCurrentDate(datapoint, index, datapoints, distance) {
                const currentDateIndex = datapoints.findIndex((d) => d.date === this.currentDateByEntityBaseId.get(datapoint.entityBaseId));
                return (currentDateIndex - index <= distance && currentDateIndex - index >= 0);
            }
            getStrokeColor(serie) {
                var _a;
                const theme = this.datasetThemes.find((theme) => theme.entityBaseId == serie.entityBaseId);
                if (!theme)
                    throw new Error("Theme not found");
                return (_a = theme.palette.lineColor.get(serie.symbol)) !== null && _a !== void 0 ? _a : "";
            }
            getStrokeWidth(serie, type) {
                if (type === "main") {
                    if (serie.symbol === "CompuSportRating") {
                        return 3.5;
                    }
                    else if (serie.symbol == "TCSR") {
                        return 1.5;
                    }
                    return 1;
                }
                else {
                    if (serie.symbol === "CompuSportRating") {
                        return 2;
                    }
                    else if (serie.symbol == "TCSR") {
                        return 0.5;
                    }
                    return 0.35;
                }
            }
            removePoints() {
                if (this.svg) {
                    this.svg.selectAll(".point").remove();
                }
            }
            drawPoints() {
                this.removePoints();
                this.serie
                    .selectAll("circle")
                    .data((s) => s.datapoints.filter((d) => {
                    var _a;
                    return !isNaN((_a = d.value) !== null && _a !== void 0 ? _a : NaN) &&
                        (d.isPremiumLocked != true || d.statFieldId == "CompuSportRating");
                }))
                    .join("circle")
                    .attr("class", "point")
                    .attr("cx", (d) => { var _a; return (_a = this.xScale(d.date)) !== null && _a !== void 0 ? _a : -1; })
                    .attr("cy", (d) => this.yScale(d.value))
                    .attr("r", (d) => {
                    if (d.statFieldId === "CompuSportRating" &&
                        d.date === this.currentDateByEntityBaseId.get(d.entityBaseId)) {
                        return 8;
                    }
                    if (this.scopeDates.length >= 24 || this.entityBaseIds.size > 1)
                        return 0;
                    return d.statFieldId === "CompuSportRating" ? 3 : 2;
                })
                    .attr("fill", this.getPointColor.bind(this));
            }
            getPointColor(datapoint) {
                var _a;
                const theme = this.datasetThemes.find((theme) => theme.entityBaseId == datapoint.entityBaseId);
                if (!theme)
                    throw new Error("Theme not found");
                return (_a = theme.palette.pointColor.get(datapoint.statFieldId)) !== null && _a !== void 0 ? _a : "";
            }
            setBisector() {
                this.bisect = d3.bisector((d) => d).center;
            }
            removeTooltip() {
                if (this.tooltip) {
                    this.tooltip.remove();
                }
            }
            removeMarkerTooltip() {
                if (this.markerTooltip) {
                    this.markerTooltip.remove();
                }
            }
            removeSVG() {
                if (this.svg) {
                    this.svg.remove();
                }
            }
            setTooltip() {
                this.removeTooltip();
                const tooltipHTML = document.createElement("div");
                tooltipHTML.setAttribute("class", "csrchart__tooltip");
                this.chartContainerElement.appendChild(tooltipHTML);
                this.tooltip = d3.select(tooltipHTML);
            }
            setMarkerTooltip() {
                this.removeMarkerTooltip();
                const tooltipHTML = document.createElement("div");
                tooltipHTML.setAttribute("class", "csr-chart__marker-tooltip");
                this.chartContainerElement.appendChild(tooltipHTML);
                this.markerTooltip = d3.select(tooltipHTML);
            }
            appendSVGNode() {
                const svgNode = this.svg.node();
                if (!(svgNode instanceof SVGSVGElement)) {
                    throw new Error("SVG node not found.");
                }
                this.chartContainerElement.appendChild(svgNode);
            }
            setExplanationForSelectedDatapoints() {
                var _a, _b;
                try {
                    const explanationSectionElement = this.rootElement.querySelector(".csr-chart__explanation-section");
                    if (!explanationSectionElement) {
                        throw new Error("Explanation section element not found.");
                    }
                    const currentDatapoints = this.scopeDatapoints.filter((d) => d.date === this.currentDate);
                    if (currentDatapoints.length != 2) {
                        throw new Error("Current datapoints not found.");
                    }
                    const currentDatapointCSR = currentDatapoints.find((d) => d.statFieldId === "CompuSportRating");
                    const datapointsTCSR = this.datapoints.filter((d) => d.statFieldId === "TCSR");
                    const indexOfCurrentDatapointTCSR = datapointsTCSR.findIndex((d) => d.date === this.currentDate);
                    const datapointsForMathEquation = datapointsTCSR.slice(Math.max(0, indexOfCurrentDatapointTCSR - 11), Math.min(indexOfCurrentDatapointTCSR + 1, datapointsTCSR.length - 1));
                    // Check if currentDate is included, if not append it to the end
                    const currentDateIncluded = datapointsForMathEquation.some((d) => d.date === this.currentDate);
                    if (!currentDateIncluded) {
                        const currentDatapointTCSR = datapointsTCSR.find((d) => d.date === this.currentDate);
                        if (currentDatapointTCSR) {
                            datapointsForMathEquation.push(currentDatapointTCSR);
                        }
                    }
                    // If more than 12 datapoints, slice to last 12
                    if (datapointsForMathEquation.length > 12) {
                        datapointsForMathEquation.splice(0, datapointsForMathEquation.length - 12);
                    }
                    if (!datapointsForMathEquation.length) {
                        explanationSectionElement.innerHTML = "";
                        explanationSectionElement.setAttribute("data-explanation", "");
                        return;
                    }
                    if (!currentDatapointCSR) {
                        explanationSectionElement.innerHTML = "";
                        explanationSectionElement.setAttribute("data-explanation", "");
                        return;
                    }
                    explanationSectionElement.setAttribute("data-explanation", JSON.stringify({ currentDatapointCSR, datapointsForMathEquation }));
                    let titlePrefix = "";
                    if (this.isLoggedUser && this.entityBaseIds.size === 1) {
                        titlePrefix = currentDatapointCSR.isEstimated
                            ? JSRess.ApproximationOfYourNextCSR
                            : JSRess.YourCSROnThisDate;
                    }
                    else {
                        titlePrefix = currentDatapointCSR.isEstimated
                            ? JSRess.CSRApproximationOnThisDate
                            : JSRess.CSROnThisDate;
                    }
                    let title = `<div class="csr-chart__explanation-section__title">${titlePrefix}</div>`;
                    if (this.hideEverythingButChart && this.defaultScope == "max") {
                        title = `<div class="csr-chart__explanation-section__title csr-chart__explanation-section__title--small">${JSRess.CSRComparison}</div>`;
                    }
                    const updateTimingMarkup = !currentDatapointCSR.isEstimated &&
                        this.explanationUpdatedInTheMorningText
                        ? `<div class="csr-chart__explanation-section__context">${this.explanationUpdatedInTheMorningText}</div>`
                        : "";
                    const subtitle = `<div class="csr-chart__explanation-section__subtitle"><span class="csr-chart__explanation-section__value" style="color: ${(_a = this.datasetThemes[0].palette.color.get("CompuSportRating")) !== null && _a !== void 0 ? _a : "white"}; ">${currentDatapointCSR.value}</span><span class="csr-chart__explanation-section__question-mark">?</span></div>`;
                    let mathEquationResult = "";
                    for (let i = 0; i < datapointsTCSR.length; i++) {
                        const datapoint = datapointsTCSR[i];
                        const value = datapoint.value;
                        const color = datapoint.isEstimated
                            ? "white"
                            : (_b = this.datasetThemes[0].palette.color.get("TCSR")) !== null && _b !== void 0 ? _b : "white";
                        const opacity = datapoint.isEstimated ? 0.8 : 1;
                        const fontWeight = datapoint.isEstimated ? 400 : 600;
                        const fontStyle = "normal";
                        if (i === 0) {
                            mathEquationResult += `(<span style="color: ${color}; font-weight: ${fontWeight}; opacity: ${opacity}; font-style: ${fontStyle};">${value}</span>`;
                        }
                        else {
                            mathEquationResult += ` + <span style="color: ${color}; font-weight: ${fontWeight}; opacity: ${opacity}; font-style: ${fontStyle};">${value}</span>`;
                        }
                        if (i === datapointsTCSR.length - 1) {
                            mathEquationResult += `)`;
                        }
                    }
                    const mathEquationId = `csr-chart-${this.id}-math-equation-result`;
                    const mathEquationClass = "csr-chart__math-equation-result";
                    const mathEquationStyle = `display: none; opacity: 0.7; margin-top: 12px; font-size: 1.1em; /*border-bottom: 1px solid rgba(255,255,255,0.7); margin-bottom: 4px; padding-bottom: 4px;*/`;
                    mathEquationResult += ` <span style="font-weight: 600; font-size: 1.2em; color: white;">/ ${datapointsTCSR.length}</span>`;
                    const mathEquationHTML = datapointsForMathEquation.length == 12
                        ? `<div id="${mathEquationId}" class="${mathEquationClass}" style="${mathEquationStyle}">${mathEquationResult}</div>`
                        : "";
                    explanationSectionElement.innerHTML = `
          ${title}
          ${this.entityBaseIds.size > 1 ? "" : updateTimingMarkup}
          ${this.entityBaseIds.size > 1 ? "" : subtitle}
          ${this.entityBaseIds.size > 1 ? "" : mathEquationHTML}`;
                }
                catch (error) {
                    console.error(error);
                }
            }
            handleResize() {
                return __awaiter(this, void 0, void 0, function* () {
                    if (this.resizeTimeout) {
                        clearTimeout(this.resizeTimeout);
                    }
                    this.resizeTimeout = setTimeout(() => __awaiter(this, void 0, void 0, function* () {
                        this.resizeTimeout = null;
                        yield this.reRender({ isResizing: true });
                    }), 500);
                });
            }
            bindEvents() {
                CS.DOM.$win.offon(`resize.${this.ControlId}-${this.id}`, this.handleResize.bind(this));
                const scopeButtons = this.rootElement.querySelectorAll(".csr-chart__scopes-button");
                if (scopeButtons && !this.preventInteraction) {
                    scopeButtons.forEach((scopeButton) => {
                        scopeButton.addEventListener("click", this.handleScopeButtonClick.bind(this));
                    });
                }
                this.rootElement
                    .querySelectorAll(".csr-chart__scroll-button")
                    .forEach((button) => {
                    button.addEventListener("click", this.handleScrollButtonClick.bind(this));
                });
                const dateSelect = this.rootElement.querySelector(".csr-chart__dates-select");
                if (dateSelect && !this.preventInteraction) {
                    dateSelect.addEventListener("change", this.handleDateSelectChange.bind(this));
                }
                const explanationSection = this.rootElement.querySelector(".csr-chart__explanation-section");
                if (explanationSection && !this.preventInteraction) {
                    explanationSection.addEventListener("click", this.handleSubtitleClick.bind(this));
                }
            }
            handleSubtitleClick(event) {
                return __awaiter(this, void 0, void 0, function* () {
                    var _a, _b;
                    try {
                        if (this.state !== ChartStateEnum.Ready) {
                            return;
                        }
                        const explanationSection = this.rootElement.querySelector(".csr-chart__explanation-section");
                        if (!explanationSection) {
                            return;
                        }
                        const explanationDataString = explanationSection.getAttribute("data-explanation");
                        if (!explanationDataString) {
                            return;
                        }
                        const explanationData = JSON.parse(explanationDataString);
                        const currentDatapointCSR = explanationData.currentDatapointCSR;
                        const datapointsForMathEquation = explanationData.datapointsForMathEquation;
                        let htmlMessage = "<div>";
                        const lastDateLabel = this.formatLocalizedDisplayDate(datapointsForMathEquation[datapointsForMathEquation.length - 1].date);
                        const title = JSRess.CSRCalculationForTheFollowingDate;
                        htmlMessage += `<div class="csrchartv2__csr-chart__subtitle__title" style="">${title}</div>`;
                        htmlMessage += `<div class="csrchartv2__csr-chart__subtitle__title" style="margin-bottom: 16px; font-weight: 600;">${lastDateLabel}</div>`;
                        let sum = 0;
                        for (let i = 0; i < datapointsForMathEquation.length; i++) {
                            const datapoint = datapointsForMathEquation[i];
                            sum += datapoint.value;
                            const value = datapoint.value;
                            const color = datapoint.isEstimated
                                ? "white"
                                : (_a = this.datasetThemes[0].palette.color.get("TCSR")) !== null && _a !== void 0 ? _a : "white";
                            const opacity = datapoint.isEstimated ? 0.8 : 1;
                            const fontWeight = datapoint.isEstimated ? 400 : 600;
                            const fontStyle = "normal";
                            const dateLabel = this.formatLocalizedDisplayDate(datapoint.date);
                            const label = datapoint.isEstimated
                                ? JSRess.ActualTCSR
                                : CS.Helper.formatString(JSRess.TCSROnXDate, dateLabel);
                            let datapointHTML = `<div class="csrchartv2__csr-chart__subtitle__datapoint">`;
                            let plusSignOpacity = 0;
                            if (i !== 0) {
                                plusSignOpacity = 1;
                            }
                            12;
                            datapointHTML += `<span class="csrchartv2__csr-chart__subtitle__datapoint__plus" style="opacity: ${plusSignOpacity};">+ </span>`;
                            datapointHTML += `<span class="csrchartv2__csr-chart__subtitle__datapoint__value" style="color: ${color}; font-weight: ${fontWeight}; font-style: ${fontStyle};">${datapoint.value}</span>`;
                            datapointHTML += `<span class="csrchartv2__csr-chart__subtitle__datapoint__label" style="font-style: italic; opacity: 0.5;"> ${label}</span>`;
                            datapointHTML += `</div>`;
                            htmlMessage += datapointHTML;
                        }
                        htmlMessage += `<div class="csrchartv2__csr-chart__subtitle__total" style="  margin-top: 8px;   font-weight: 600;/* color: white; */font-size: 1.2em;">= ${sum}</div>`;
                        htmlMessage += `<div class="csrchartv2__csr-chart__subtitle__final-equation" style="font-weight: 600; margin-top: 12px; font-size: 1.5em; color: white; display: flex; justify-content: flex-start; align-items: center; gap: 8px; background: rgba(255, 255, 255, 0.05); border-radius: 8px; padding: 4px 8px;">${sum} / ${datapointsForMathEquation.length} = <span style="color: ${(_b = this.datasetThemes[0].palette.color.get("CompuSportRating")) !== null && _b !== void 0 ? _b : "white"}; font-weight: 900;">${currentDatapointCSR.value}</span></div>`;
                        htmlMessage += "</div>";
                        Controls.Popup.ShowMessage("", htmlMessage);
                    }
                    catch (error) {
                        console.error("Error while handling subtitle click.", error);
                    }
                });
            }
            handleDateSelectChange(event) {
                const target = event.target;
                const date = target.value;
                this.setCurrentDate(date, false);
            }
            handleScrollButtonClick(event) {
                const target = event.target;
                const count = Number(target.getAttribute("data-count"));
                if (isNaN(count))
                    return;
                const currentDateIndexInDataset = Array.from(this.datasetDates).indexOf(this.currentDate);
                let newDateIndexInDataset = Math.min(currentDateIndexInDataset + count, this.datasetDates.size - 1);
                if (newDateIndexInDataset < 0) {
                    newDateIndexInDataset = 0;
                }
                else if (newDateIndexInDataset > this.datasetDates.size - 1) {
                    newDateIndexInDataset = this.datasetDates.size - 1;
                }
                const newDate = Array.from(this.datasetDates)[newDateIndexInDataset];
                this.setCurrentDate(newDate);
            }
            setCurrentDate(newDate, shouldUpdateSelect = true) {
                const newDateIndexInDataset = this.datasetDates.has(newDate)
                    ? Array.from(this.datasetDates).indexOf(newDate)
                    : -1;
                if (newDateIndexInDataset === -1) {
                    return;
                }
                const newDateIndexInScope = this.scopeDates.indexOf(newDate);
                const firstScopeDateIndexInDataset = Array.from(this.datasetDates).indexOf(this.scopeDates[0]);
                const lastScopeDateIndexInDataset = Array.from(this.datasetDates).indexOf(this.scopeDates[this.scopeDates.length - 1]);
                const datesBeforeScope = Array.from(this.datasetDates).slice(0, firstScopeDateIndexInDataset);
                const datesAfterScope = Array.from(this.datasetDates).slice(lastScopeDateIndexInDataset + 1, this.datasetDates.size);
                const isNewDateIndexInScope = newDateIndexInScope !== -1;
                const shouldAddDatesBeforeScope = isNewDateIndexInScope
                    ? newDateIndexInScope < 11 &&
                        newDateIndexInDataset > newDateIndexInScope
                    : newDateIndexInDataset < firstScopeDateIndexInDataset;
                const shouldAddDatesAfterScope = !isNewDateIndexInScope &&
                    newDateIndexInDataset > lastScopeDateIndexInDataset;
                if (shouldAddDatesBeforeScope) {
                    if (newDateIndexInScope == -1) {
                        const datesToAdd = 11;
                        const newDateIndex = datesBeforeScope.indexOf(newDate);
                        const newScopeDates = datesBeforeScope
                            .slice(Math.max(0, newDateIndex - datesToAdd), firstScopeDateIndexInDataset)
                            .sort()
                            .slice(0, this.currentScope.value);
                        this.setScopeDates(newScopeDates);
                        this.setScopeDatapoints();
                    }
                    else {
                        let datesToAdd = 11 - newDateIndexInScope;
                        const newDates = datesBeforeScope.slice(Math.max(0, datesBeforeScope.length - datesToAdd), datesBeforeScope.length);
                        datesToAdd = Math.min(datesToAdd, newDates.length);
                        const newScopeDates = newDates
                            .concat(this.scopeDates.slice(0, this.scopeDates.length - datesToAdd))
                            .sort();
                        this.setScopeDates(newScopeDates);
                        this.setScopeDatapoints();
                    }
                }
                if (shouldAddDatesAfterScope) {
                    let datesToAdd = newDateIndexInDataset - lastScopeDateIndexInDataset;
                    const newDates = datesAfterScope.slice(0, datesToAdd);
                    datesToAdd = Math.min(datesToAdd, newDates.length);
                    let newScopeDates = this.scopeDates
                        .slice(datesToAdd)
                        .concat(newDates)
                        .sort();
                    if (newScopeDates.length > this.currentScope.value) {
                        newScopeDates = newScopeDates.slice(newScopeDates.length - this.currentScope.value);
                    }
                    this.setScopeDates(newScopeDates);
                    this.setScopeDatapoints();
                }
                this.currentDate = newDate;
                this.setCurrentData();
                if (shouldUpdateSelect) {
                    const dateSelect = this.rootElement.querySelector(".csr-chart__dates-select");
                    if (dateSelect) {
                        dateSelect.value = newDate;
                    }
                }
                this.reRender();
            }
            setCurrentData() {
                this.setCurrentDateByEntityBaseId();
                this.setCurrentValueByKey();
            }
            setCurrentDateByEntityBaseId() {
                this.currentDateByEntityBaseId = new Map();
                this.entityBaseIds.forEach((entityBaseId) => {
                    const datapoints = this.datapoints.filter((datapoint) => datapoint.entityBaseId == entityBaseId &&
                        datapoint.date == this.currentDate);
                    if (datapoints.length) {
                        this.currentDateByEntityBaseId.set(entityBaseId, datapoints[0].date);
                    }
                    else {
                        const datapoints = this.datapoints.filter((datapoint) => datapoint.entityBaseId == entityBaseId &&
                            new Date(datapoint.date) <= new Date(this.currentDate));
                        if (datapoints.length) {
                            const closestDatapoint = datapoints.reduce((a, b) => new Date(a.date) > new Date(b.date) ? a : b);
                            this.currentDateByEntityBaseId.set(entityBaseId, closestDatapoint.date);
                        }
                    }
                });
            }
            setCurrentValueByKey() {
                this.currentValueByKey = new Map();
                this.keys.forEach((key) => {
                    const [entityBaseId, symbol] = key.split(":");
                    const datapoints = this.datapoints.filter((datapoint) => datapoint.entityBaseId == entityBaseId &&
                        datapoint.statFieldId == symbol &&
                        datapoint.date == this.currentDate);
                    if (datapoints.length) {
                        this.currentValueByKey.set(key, datapoints[0].value);
                    }
                    else {
                        const datapoints = this.datapoints.filter((datapoint) => datapoint.entityBaseId == entityBaseId &&
                            datapoint.statFieldId == symbol &&
                            new Date(datapoint.date) <= new Date(this.currentDate));
                        if (datapoints.length) {
                            const closestDatapoint = datapoints.reduce((a, b) => new Date(a.date) > new Date(b.date) ? a : b);
                            this.currentValueByKey.set(key, closestDatapoint.value);
                        }
                    }
                });
            }
            handleScopeButtonClick(event) {
                return __awaiter(this, void 0, void 0, function* () {
                    const target = event.target;
                    const isSelected = target.classList.contains("csr-chart__scopes-button--selected");
                    if (isSelected) {
                        return;
                    }
                    const value = Number(target.getAttribute("data-value"));
                    if (isNaN(value)) {
                        return;
                    }
                    yield this.setScope(value);
                });
            }
            setScope(value) {
                return __awaiter(this, void 0, void 0, function* () {
                    this.scopes.forEach((scope) => {
                        scope.selected = scope.value == Number(value);
                    });
                    this.setScopeUI();
                    this.setScopeDates();
                    this.setScopeDatapoints();
                    this.setDefaultCurrentDate();
                    yield this.reRender();
                });
            }
        }
        Controls.CSRChartV2 = CSRChartV2;
        let ChartStateEnum;
        (function (ChartStateEnum) {
            ChartStateEnum["Initializing"] = "initializing";
            ChartStateEnum["Unready"] = "unready";
            ChartStateEnum["Ready"] = "ready";
            ChartStateEnum["Running"] = "running";
            ChartStateEnum["Stopping"] = "stopping";
            ChartStateEnum["Stopped"] = "stopped";
            ChartStateEnum["Error"] = "error";
            ChartStateEnum["Finished"] = "finished";
            ChartStateEnum["Destroying"] = "destroying";
            ChartStateEnum["Loading"] = "loading";
        })(ChartStateEnum || (ChartStateEnum = {}));
        (function (CSRChartV2) {
            class Events {
                static WeekSelected(param) {
                    Controls.RegisterEvent(CSRChartV2, EventNames.WeekSelected, param);
                }
            }
            CSRChartV2.Events = Events;
            class EventNames {
            }
            EventNames.WeekSelected = "week-selected";
            CSRChartV2.EventNames = EventNames;
        })(CSRChartV2 = Controls.CSRChartV2 || (Controls.CSRChartV2 = {}));
    })(Controls = CS.Controls || (CS.Controls = {}));
})(CS || (CS = {}));

//# sourceMappingURL=CSRChartV2.js.map
